var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M69.105,48c0-3.616-2.473-6.658-5.813-7.545V28.562c0-0.74-0.408-1.419-1.062-1.766c-0.654-0.349-1.445-0.306-2.059,0.109 L44.147,37.733H20.516c-1.104,0-2,0.896-2,2v16.533c0,1.104,0.896,2,2,2h2.773l3.943,15.04c0.23,0.88,1.025,1.493,1.935,1.493h9.74 c0.62,0,1.205-0.287,1.583-0.778c0.378-0.49,0.508-1.129,0.351-1.729l-3.677-14.026h6.983l16.025,10.829 c0.337,0.228,0.729,0.343,1.12,0.343c0.321,0,0.644-0.077,0.938-0.233c0.653-0.348,1.062-1.026,1.062-1.767V55.544 C66.633,54.658,69.105,51.616,69.105,48z M22.516,41.733h20.243v12.533h-8.187h-9.74h-2.316V41.733z M36.314,70.8h-5.605 l-3.286-12.533h5.605L36.314,70.8z M59.292,63.673l-12.533-8.469V40.796l12.533-8.469V63.673z M63.292,51.232v-6.465 c1.084,0.673,1.813,1.865,1.813,3.233C65.105,49.367,64.376,50.559,63.292,51.232z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.285,46h-8.737c-1.104,0-2,0.896-2,2s0.896,2,2,2h8.737c1.104,0,2-0.896,2-2S83.39,46,82.285,46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.761,56.729c-0.781-0.781-2.047-0.781-2.828,0c-0.781,0.78-0.781,2.047,0,2.828l6.178,6.179 c0.391,0.391,0.902,0.586,1.414,0.586s1.023-0.195,1.414-0.586c0.781-0.78,0.781-2.047,0-2.828L70.761,56.729z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.347,39.856c0.512,0,1.023-0.195,1.414-0.586l6.178-6.178c0.781-0.781,0.781-2.047,0-2.828 c-0.781-0.781-2.047-0.781-2.828,0l-6.178,6.178c-0.781,0.781-0.781,2.047,0,2.828C68.323,39.661,68.835,39.856,69.347,39.856z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketing);
export default __webpack_public_path__ + "static/media/marketing.7093342e66a0d4e384afcf56b77df1e6.svg";
export { ForwardRef as ReactComponent };